import { createFileRoute } from '@tanstack/react-router';
import { Upgrade } from '../../organisms/Upgrade';

export const Route = createFileRoute('/_authenticated/upgrade')({
  component: Upgrade,
});
